import React from 'react';
import PropTypes from 'prop-types';
import { handleAd } from '../utils/handleAd';
import Chip from 'Chip';

/**
 * 定义 Ad 组件
 */
class Ad extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        styleName: PropTypes.string,
    };

    container = React.createRef();

    async componentDidMount() {
        const { content } = this.props;

        try {
            const callbackFn = await handleAd(content);

            callbackFn(this.container.current, content.data);
        } catch (error) {
            const adData = {};

            /* eslint-disable no-undef */
            if (allData) {
                for (const [key, value] of Object.entries(allData)) {
                    if (value === content) {
                        adData['key'] = key;
                        adData['value'] = value;
                    }
                }
            }
            /* eslint-enable no-undef */

            error.message = `AdError - ${error.message};`;
            error.message += `AdInfo - ${JSON.stringify(adData)}`;

            console.error(error);
            console.error('AdError - AdData', adData);

            if (window && window.BJ_REPORT) window.BJ_REPORT.report(error, false, 'ad');
        }
    }

    /**
     * 渲染组件
     */
    render() {
        const { styleName } = this.props;

        return <div className={styleName} ref={this.container} />;
    }
}

class AdExtend extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        styleName: PropTypes.string,
    };

    render() {
        const { styleName, content } = this.props;

        if (content) {
            const { desc, code = '' } = content;

            if (desc) {
                return (
                    <Chip
                        id={desc.id}
                        groupName="ad"
                        type={desc.type}
                        title={desc.title}
                        name={desc.key}
                        user="dev"
                        code={code}
                        content={this.props.content}>
                        <Ad styleName={styleName} />
                    </Chip>
                );
            } else {
                return <Ad styleName={styleName} content={content} />;
            }
        } else {
            return <div />;
        }
    }
}
export default AdExtend;
